import { useState } from 'react';
import { getNetworkConfig } from '../config/contracts';

export default function TestnetBanner() {
  const [dismissed, setDismissed] = useState(false);
  const config = getNetworkConfig();

  if (dismissed || config.chainType !== 'tyjolt') return null;

  return (
    <div style={{
      background: 'linear-gradient(90deg, #7C4DFF 0%, #536DFE 50%, #448AFF 100%)',
      color: '#fff',
      padding: '8px 16px',
      fontSize: 13,
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      position: 'relative',
      zIndex: 10000,
    }}>
      <span style={{
        background: 'rgba(0,0,0,0.2)',
        borderRadius: 4,
        padding: '2px 8px',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1,
      }}>
        TESTNET
      </span>
      <span>
        TyJolt ZK Testnet — tokens have no real value. Trades are settled with real Jolt ZK proofs.
      </span>
      <button
        onClick={() => setDismissed(true)}
        style={{
          position: 'absolute',
          right: 12,
          background: 'none',
          border: 'none',
          color: 'rgba(255,255,255,0.7)',
          fontSize: 18,
          cursor: 'pointer',
          padding: '0 4px',
        }}
      >
        x
      </button>
    </div>
  );
}
